import { useEffect, useState } from "react";
import { Megaphone, TrendingUp } from "lucide-react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import StatusBadge from "../components/StatusBadge";
import { fmtDate } from "../lib/format";

function rate(a, b) { return b ? `${Math.round((a / b) * 100)}%` : "—"; }

export default function Campaigns() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/campaigns").then(({ data }) => setRows(data)); }, []);

  return (
    <div>
      <PageHeader title="Campagne B2B" subtitle="Lead Generation e prospecting multicanale" />
      {rows.length === 0 ? <div className="bg-white rounded-xl border border-slate-200 py-14 text-center text-slate-400"><Megaphone className="w-8 h-8 mx-auto mb-2 opacity-40" />Nessuna campagna</div> : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-3">
          {rows.map((c) => (
            <div key={c.id} data-testid={`campaign-card-${c.id}`} className="bg-white rounded-xl border border-slate-200 p-5">
              <div className="flex items-start justify-between">
                <div><p className="font-heading font-semibold text-slate-800">{c.name}</p><p className="text-xs text-slate-400 mt-0.5">{c.channel} · {c.market}</p></div>
                <StatusBadge group="opp_status" value={c.status === "attiva" ? "open" : "won"} />
              </div>
              <div className="grid grid-cols-3 gap-2 mt-4 text-center">
                {[["Prospect", c.prospects], ["Inviti", c.invites_sent], ["Risposte", c.replies], ["Meeting", c.meetings], ["Opportunità", c.opportunities], ["Clienti", c.clients]].map(([k, v]) => (
                  <div key={k} className="bg-slate-50 rounded-lg py-2"><p className="text-lg font-bold font-heading text-slate-800">{v ?? 0}</p><p className="text-[10px] text-slate-400">{k}</p></div>
                ))}
              </div>
              <div className="mt-4 pt-3 border-t border-slate-100 space-y-1.5 text-xs">
                {[["Acceptance Rate", rate(c.invites_accepted, c.invites_sent)], ["Response Rate", rate(c.replies, c.messages_sent)], ["Positive Rate", rate(c.positive_replies, c.replies)], ["Meeting Rate", rate(c.meetings, c.replies)], ["Conversion Rate", rate(c.clients, c.prospects)]].map(([k, v]) => (
                  <div key={k} className="flex justify-between"><span className="text-slate-500">{k}</span><span className="font-mono font-semibold text-teal-700">{v}</span></div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
